/** Ease with a soft start/end — feels smoother than linear “smooth” over long distances. */
function easeInOutQuint(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 - Math.pow(-2 * t + 2, 5) / 2
}

/**
 * Scroll so `el` lands below a fixed header.
 * @param {HTMLElement} el
 * @param {{ duration?: number, offset?: number }} options — duration default ~1s, offset for fixed navbar
 */
export function smoothScrollToElement(el, options = {}) {
  if (!el || typeof el.getBoundingClientRect !== 'function') return Promise.resolve()

  const offset = options.offset ?? 100
  const targetY = Math.max(0, el.getBoundingClientRect().top + window.scrollY - offset)

  const prefersReduced =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (prefersReduced) {
    window.scrollTo(0, targetY)
    return Promise.resolve()
  }

  const duration = options.duration ?? 1050
  const ease = options.ease ?? easeInOutQuint

  const startY = window.scrollY
  const dist = targetY - startY
  if (Math.abs(dist) < 1.5) return Promise.resolve()

  return new Promise((resolve) => {
    let startTime = null
    function step(now) {
      if (!startTime) startTime = now
      const elapsed = now - startTime
      const t = Math.min(elapsed / duration, 1)
      const y = startY + dist * ease(t)
      window.scrollTo(0, y)
      if (t < 1) requestAnimationFrame(step)
      else resolve()
    }
    requestAnimationFrame(step)
  })
}

/**
 * @param {string} hash — e.g. `#pricing`
 */
export function smoothScrollToHash(hash, options = {}) {
  if (!hash || hash === '#') return Promise.resolve()
  const id = hash.startsWith('#') ? hash.slice(1) : hash
  let el = id ? document.getElementById(id) : null
  if (!el) {
    try {
      el = document.querySelector(hash)
    } catch {
      // querySelector rejects IDs that start with a digit (e.g. legal section anchors).
    }
  }
  return smoothScrollToElement(el, options)
}
